<template>
<!--  <cxl-vbden-common-->
<!--    :isOpen="isOpen"-->
<!--    :quote="quote"-->
<!--    :flowId="flowId"-->
<!--    :stepId="stepId"-->
<!--    :nextVbIncomingProcess="nextVbIncomingProcess"-->
<!--    :isProcessing="isProcessing"-->
<!--    @closeDialog="$emit('closeDialog')"-->
<!--    @closed="$emit('closed')"-->
<!--    @submit="submit"-->
<!--    ref="cxlDialog"-->
<!--  />-->
  <cxl-vbden-cho-cxl-ld-n
    v-if="isOpenLDSoDuyetDialog"
    :isOpen="isOpen"
    :quote="quote"
    :flowId="flowId"
    :stepId="stepId"
    :flag="flag"
    :docId="docId"
    :nextVbIncomingProcess="nextVbIncomingProcess"
    :isProcessing="isProcessing"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('closed')"
    @submit="submit"
  />
  <cxl-vbden-ld-duyet
    v-else-if="isOpenLDDuyetDialog"
    :isOpen="isOpen"
    :quote="quote"
    :flowId="flowId"
    :stepId="stepId"
    :flag="flag"
    :docId="docId"
    :nextVbIncomingProcess="nextVbIncomingProcess"
    :isProcessing="isProcessing"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('closed')"
    @submit="submit"
  />
  <cxl-vbden-cho-cxl-ld
    v-else-if="isOpenDialog"
    :isOpen="isOpen"
    :quote="quote"
    :flowId="flowId"
    :stepId="stepId"
    :flag="flag"
    :docId="docId"
    :nextVbIncomingProcess="nextVbIncomingProcess"
    :isProcessing="isProcessing"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('closed')"
    @submit="submit"
  />

</template>
<script>
  import VuePerfectScrollbar from "vue-perfect-scrollbar";
  import buildShortNameFilter from "../../../filters/buildShortNameFilter.js";
  import constants from "../../../constants";
  import handleRequestErrorMixin from "../../handleRequestErrorMixin";
  import vbIncomingProcessService from "../../../services/vbIncomingProcessService";
  import handlersTreeMixin from "../../../mixins/handlersTreeMixin";
  import CxlVbdenCommon from "./cxl-vbden-common";
  import CxlVbdenChoCxlLdN from "./cxl-vbden-cho-cxl-ld-n";
  import CxlVbdenChoCxlLd from "./cxl-vbden-cho-cxl-ld";
  import CxlVbdenLdDuyet from "./cxl-vbden-ld-duyet";
  import vbFlowInstanceService from "../../../services/vbFlowInstanceService";
  import {EventBus} from "../../../event-bus";
  import vbIncomingChoCxlProcessService from "../../../services/vbIncomingChoCxlProcessService";
  import DocInSelectHandler from "./DocInSelectHandler";
  import vbStepService from "../../../services/vbStepService";

  export default {
    name: "cxl-vbden-dialog",
    mixins: [handleRequestErrorMixin, handlersTreeMixin],
    filters: {buildShortNameFilter},
    props: ["isOpen", "quote", "incomingProcessId", "vbStep","is-assistant-sign"],
    components: {
      CxlVbdenLdDuyet,
      CxlVbdenCommon,
      CxlVbdenChoCxlLd,
      CxlVbdenChoCxlLdN,
      dialogTemplate: () => import("../../common/custom-dialog.vue"),
      chuyenXuLyHashtag: () => import("./chuyenXuLy-hashtag.vue"),
      VuePerfectScrollbar,
      DocInSelectHandler
    },

    data() {
      return {
        vbIncomingProcess: null,
        nextVbIncomingProcess: null,
        isProcessing: false,
        flowInstance: null,
        preStep: null,
        isOpenDialog: false,
      };
    },

    watch: {},

    computed: {
      flowInstanceId() {
        return this.vbIncomingProcess
          ? this.vbIncomingProcess.flowInstanceId
          : null;
      },
      docId() {
        return this.vbIncomingProcess ? this.vbIncomingProcess.docId : null;
      },
      flowId() {
        return this.flowInstance ? this.flowInstance.flowId : null;
      },
      stepId() {
        return this.vbIncomingProcess ? this.vbIncomingProcess.stepId : null;
      },

      flag() {
        return this.vbStep ? this.vbStep.flag : null;
      },

      preFlag() {
        return this.preStep ? this.preStep.flag : null;
      },

      isOpenLDSoDuyetDialog() {
        return this.flag === constants.STEP.FLAG_CHO_DUYET_CXL && this.isOpenDialog;
      },

      isOpenLDDuyetDialog() {
        return this.flag === constants.STEP.FLAG_DUYET_CXL && this.preFlag === constants.STEP.FLAG_CHO_DUYET_CXL && this.isOpenDialog;
      }
    },

    created() {
      this.loadIncomingProcess()
        .then(() => this.loadNextVbIncomingProcesses())
        .then(() => this.loadFlowInstance())
        .then(() => this.loadPreviousStep())
        .then(() => this.isOpenDialog = true)
    },

    methods: {
      loadPreviousStep() {
        return vbStepService.getPreStepByVbIncomingProcessId(this.vbIncomingProcess.parentId)
        .then(res => this.preStep = res.data)
      },

      loadFlowInstance() {
        return vbFlowInstanceService
          .findById(this.flowInstanceId)
          .then(response => (this.flowInstance = response.data));
      },

      loadNextVbIncomingProcesses() {
        return vbIncomingProcessService
          .nextVbIncomingProcesses(this.incomingProcessId, this.docId)
          .then(response => {
              this.nextVbIncomingProcess = response.data;
          }
        );
      },

      loadIncomingProcess() {
        return vbIncomingProcessService
          .findById(this.incomingProcessId)
          .then(response => {
            this.vbIncomingProcess = response.data;
          });
      },

      chuyenXuLi(event) {
        let processHandlerForms = event.handlersData
          .filter(item => item.stepType === constants.STEP.STEP_TYPE.CANHAN)
          .map(item => {
            let userDeptRole = item.userDeptRole;
            return {
              userId: userDeptRole.userId,
              deptId: userDeptRole.deptId,
              roleId: userDeptRole.roleId,
              positionId: userDeptRole.positionId,
              userDeptRoleId: userDeptRole.id,
              processType: item.processType,
              stepId: item.stepId
            };
          });

        let processHandlerDeptForms = event.handlersData
          .filter(item => item.stepType === constants.STEP.STEP_TYPE.DONVI)
          .map(item => {
            return {
              deptId: item.department.id,
              stepId: item.stepId,
              processType: item.processType
            };
          });

        let processHandlerFormLogs
        if (event.handlersData2 != null){
           processHandlerFormLogs = event.handlersData2
            .map(item => {
              let userDeptRole
              if (item.userDeptRole != null){
                userDeptRole = item.userDeptRole
              } else {
                userDeptRole = item.department
              }
              return {
                fullName: userDeptRole.fullName,
                positionName: userDeptRole.positionName,
                roleName: userDeptRole.roleName,
                deptName: userDeptRole.deptName,
                processType: item.processType
              };
            });
        }

        let submitForm = {
          incomingProcessId: this.incomingProcessId,
          flowInstanceId: this.flowInstanceId,
          flowId: this.flowId,
          stepId: this.stepId,
          content: event.note,
          isAutoAssignTask: event.isAutoAssignTask,
          processHandlerForms: processHandlerForms,
          processHandlerDeptForms: processHandlerDeptForms,
          processHandlerFormLogs: processHandlerFormLogs
        };
        this.isProcessing = true;
        return vbIncomingProcessService.chuyenXuLi(submitForm, this.docId);
      },

      saveChoChuyenXuLy(handlersData) {
        let processHandlerForms = handlersData
          .filter(item => item.stepType === constants.STEP.STEP_TYPE.CANHAN)
          .map(item => {
            let userDeptRole = item.userDeptRole;
            return {
              userId: userDeptRole.userId,
              deptId: userDeptRole.deptId,
              roleId: userDeptRole.roleId,
              positionId: userDeptRole.positionId,
              userDeptRoleId: userDeptRole.id,
              processType: item.processType,
              stepId: null
            };
          });

        let processHandlerDeptForms = handlersData
          .filter(item => item.stepType === constants.STEP.STEP_TYPE.DONVI)
          .map(item => {
            return {
              deptId: item.department.id,
              stepId: null,
              processType: item.processType
            };
          });
        let submitForm = {
          incomingProcessId: this.incomingProcessId,
          flowInstanceId: this.flowInstanceId,
          flowId: this.flowId,
          stepId: null,
          content: event ? event.note : null,
          isAutoAssignTask: event ? event.isAutoAssignTask : null,
          processHandlerForms: processHandlerForms,
          processHandlerDeptForms: processHandlerDeptForms
        };

        this.isProcessing = true;
        return vbIncomingChoCxlProcessService.saveChoChuyenXuLy(submitForm, this.docId);
      },

      submit(event) {
        this.chuyenXuLi(event)
        .then(async response => {
          if(this.flag === constants.STEP.FLAG_CHO_DUYET_CXL) {
            await this.saveChoChuyenXuLy(event.handlersData2);
          }
          EventBus.$emit('loadCounting', '');
          this.$message({
            message: "Chuyển xử lý văn bản đến thành công",
            type: "success"
          });
          this.isProcessing = false;
          this.$emit("success", {vbIncomingProcess: response.data});
        })
        .catch(error => {
          this.isProcessing = false;
          return this.commonHandleRequestError(error);
        });
      }
    }
  };
</script>
<style scoped>
  .title {
    width: 100%;
  }

  .list-checkbox {
    position: relative;
    margin-right: 10px;
  }

  .scroll-list-user {
    height: auto;
    width: 100%;
    max-width: 100%;
    max-height: 100%;
    margin: auto;
  }

  .list-checkbox .item {
    width: 90px;
    text-align: center;
    margin: 0;
  }

  .icon-close {
    position: absolute;
    right: -5px;
    font-size: 18px;
  }

  .dialog-body .display-list__selected .list-selected .header > div {
    width: 100%;
  }

  .dialog-body .display-list__selected .list-selected .body {
    padding: 0;
  }

  .dialogTransferHandling .dialog-body .list-collapse__transfer {
    display: flex;
    flex-direction: column;
  }

  .dialogTransferHandling .dialog-body .scroll-area-height_90 {
    height: 100%;
    margin-bottom: 0;
    margin-right: -13px;
  }

  .dialog-body .display-list__selected {
    height: 400px;
  }

  .dialogTransferHandling .dialog-body .display-list__selected .list-selected {
    height: calc(100% - 121px);
  }

  .dialog-body .display-list__selected .list-selected .header {
    padding-left: 10px;
    padding-right: 10px;
  }

  .dialog-body .display-list__selected .list-selected .body .list-filter {
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/views/doc-in/components/cxl-vbden-dialog.vue